import i18n from '@/lib/i18n';

import { Course } from '@/models/Course';
import { CourseLineSubCategory } from '@/models/CourseLine';
import Lesson from '@/models/Lesson';
import { Nullable } from '@/models/Model';
import ScheduledLesson from '@/models/ScheduledLesson';
import {
  formatLessonName,
  formatLessonNamePrefix,
  formatOldNames,
} from '@/utils/lesson/name';

type LessonNameSource = Pick<Lesson, 'name'> & { order?: Nullable<number> };

export type LessonNameFormatter = {
  formatName: (
    lesson?: Nullable<LessonNameSource>,
    scheduledLesson?: ScheduledLesson,
  ) => string;
  formatPrefix: typeof formatLessonNamePrefix;
};

const orderedLessonNameFormatter: LessonNameFormatter = {
  formatName: formatLessonName,
  formatPrefix: formatLessonNamePrefix,
};

const plainLessonNameFormatter: LessonNameFormatter = {
  formatName: lesson =>
    formatOldNames(lesson ? lesson.name : i18n.t('common.unassignedLesson')),
  formatPrefix: () => '',
};

type LessonNameCourseSource = Pick<Course, 'module'>;

export const createLessonNameFormatter = (
  course?: Nullable<LessonNameCourseSource>,
): LessonNameFormatter =>
  course?.module?.courseLine?.subcategory === CourseLineSubCategory.CTRL_PLAY
    ? orderedLessonNameFormatter
    : plainLessonNameFormatter;
